/**
 * 지출 증빙 자료 상세 컴포넌트
 * 계약의 지출 증빙 자료 상세 정보를 표시하는 컴포넌트입니다.
 * 현금영수증과 세금계산서의 정보를 구분하여 표시하며, 각 유형별로 필요한 정보를 보여줍니다.
 */

import { useCallback, useEffect } from "react";

import { ArticleSection } from "src/components/layout/ArticleSection";
import BaseSection from "../../../../components/layout/BaseSection";
import { ViewYmdFormat } from "src/utils";
import moment from "moment";
import ContractImageUpload from "../ContractImageUpload";
import { expenseProofTypeToText } from "../../contract-util";

/**
 * 컴포넌트 props 인터페이스
 */
interface BaseProps {
  detailData: any; // 계약 상세 데이터
}

/**
 * 지출 증빙 자료 상세 컴포넌트
 * @param detailData 계약 상세 데이터
 */
const ExpenseDocumentationDetail = ({ detailData }: BaseProps) => {
  const { expenseProofData } = detailData; // 지출 증빙 자료 데이터

  /**
   * 데이터 초기화 함수
   * 현재는 비어있는 상태로, 필요한 경우 데이터 초기화 로직을 추가할 수 있습니다.
   */
  const initDatas = useCallback(async () => {}, []);

  // 컴포넌트 마운트 시 데이터 초기화
  useEffect(() => {
    initDatas();
    console.log(["expenseProofData", expenseProofData]);
  }, [initDatas]);

  return (
    <ArticleSection
      title={"지출 증빙 자료"}
      children={
        <div>
          <div>
            <div className="flex-row flex-center">
              <BaseSection
                title={"신청 일시"}
                value={expenseProofData?.createdDate ? moment(expenseProofData?.createdDate).format(ViewYmdFormat.FULL) : "-"}
              />
              <BaseSection
                title={"현금영수증/세금계산서"}
                value={expenseProofData?.expenseProofType ? (expenseProofData?.expenseProofType === "CASHBILL" ? "현금영수증" : "세금계산서") : "-"}
              />
            </div>
            {expenseProofData?.expenseProofType !== "CASHBILL" ? (
              <div>
                <div className="flex-row flex-center">
                  <BaseSection title={"접수상태"} value={expenseProofData !== null ? "접수" : "미접수"} />
                  <BaseSection title={"사업자 등록번호"} value={expenseProofData?.identityNum ? expenseProofData?.identityNum : "-"} />
                </div>
                <div className="flex-row flex-center">
                  <BaseSection
                    title={"사업자 등록증 사본"}
                    children={<ContractImageUpload isOnlyView type={"PROOF"} images={expenseProofData?.mediaList} />}
                  />
                  <BaseSection title={"수신 이메일"} value={expenseProofData?.taxInvoiceEmail ? expenseProofData?.taxInvoiceEmail : "-"} />
                </div>
                <div className="flex-row flex-center">
                  <BaseSection title={"유선전화번호"} value={expenseProofData?.taxInvoicePhone ? expenseProofData?.taxInvoicePhone : "-"} />
                  <BaseSection
                    title={"계산서 작성일자(신청)"}
                    value={expenseProofData?.taxInvoiceDate ? moment(expenseProofData?.taxInvoiceDate).format(ViewYmdFormat.YYYY_MM_DD) : "-"}
                  />
                </div>
              </div>
            ) : (
              <div>
                <div className="flex-row flex-center">
                  <BaseSection
                    title={"식별타입"}
                    value={
                      expenseProofData?.identityType ? expenseProofTypeToText(expenseProofData?.identityType, expenseProofData?.tradeUsage) : "-"
                    }
                  />
                  <BaseSection title={"식별번호"} value={expenseProofData?.identityNum ? expenseProofData?.identityNum : "-"} />
                </div>
                <div className="flex-row flex-center">
                  <BaseSection
                    title={"현금영수증 거래구분 "}
                    value={
                      expenseProofData?.tradeUsage !== null && expenseProofData?.tradeUsage !== ""
                        ? expenseProofData?.tradeUsage === "INCOME"
                          ? "소득공제용"
                          : "지출증빙용"
                        : "-"
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
};
export default ExpenseDocumentationDetail;
